





















































































































































import { Vue, Component } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import memberStore from '../../../member.store'
import venueStore from '@/modules/venue/venue.store'
import authStore from '@/modules/auth/auth.store'
import AppButton from '@/modules/shared/components/AppButton'
import OverlayTabs from '@/modules/shared/components/OverlayTabs'
import { MemberEntity } from '@/api/member'
import { VenueEntity } from '@/api/venue'
import { PointRedemptionDialog } from '../../components/PointRedemptionDialog'
import GoogleMapDialog from '../../components/GoogleMapDialog'

@Component({
  components: {
    AppButton,
    OverlayTabs,
    PointRedemptionDialog,
    GoogleMapDialog
  },
  filters: {
    point(number: number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
})
export default class HomeShop extends Vue {
  memberModule = getModule(memberStore, this.$store)
  venueModule = getModule(venueStore, this.$store)
  authModule = getModule(authStore, this.$store)
  redeemDialog: boolean = false
  enlargedMap: boolean = false

  /* Vuex store */
  get memberId(): string {
    return this.memberModule.memberId
  }

  get member(): MemberEntity | null {
    return this.memberModule.member
  }

  get homeShop(): VenueEntity | null {
    return this.member!.homeShop
  }

  get venueId(): string {
    return this.venueModule.applicationVenueId
  }

  get applicationVenue() {
    return this.venueModule.applicationVenue
  }

  get userId() {
    return this.authModule.userId
  }

  get homeShopMap() {
    let apiKey = process.env.VUE_APP_GOOGLE_API_KEY
    if (
      !apiKey ||
      !this.homeShop ||
      !this.homeShop.latitude ||
      !this.homeShop.longitude
    ) {
      return ``
    }
    return `https://maps.googleapis.com/maps/api/staticmap?center=${this.homeShop.latitude},${this.homeShop.longitude}&zoom=17&size=500x250&maptype=roadmap&markers=color:red|${this.homeShop.latitude},${this.homeShop.longitude}&key=${process.env.VUE_APP_GOOGLE_API_KEY}`
  }

  /* Computed Properties */
  get isMe() {
    return this.memberId === this.userId
  }

  /* Hooks */
  created() {}

  /* Methods */
  async onChangeHomeShopBtnClicked() {
    if (!this.venueId) {
      this.$toast.info(this.$t('MyHomeShop.ApplicationNotAttachedToAnyVenue'))
      return
    } else if (
      this.homeShop &&
      this.venueId.replace(/-/g, '') === this.homeShop!.venueId
    ) {
      this.$toast.info(this.$t('MyHomeShop.AlreadySetVenueAsHomeShop'))
      return
    }
    try {
      await this.venueModule.setMemberHomeShop(this.memberId)
      this.$toast.success(this.$t('MyHomeShop.UpdateHomeShopSuccessfully'))
      await this.memberModule.setSelectedMember(this.memberId)
    } catch (err) {
      this.$toast.error(err)
    }
  }
}
